<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul>
          <li>
            <router-link :to="{ path: '/dashboard' }"> Ballina</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright d-flex flex-wrap">
        &copy;Designed by-
        <a href="https://www.cmd-ks.com" target="_blank">&nbsp; CMD-SOFTWARE</a>
      </div>
      <!-- Designed by -->
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
